import React from 'react';

import { PrivateRoute } from '../PrivateRoute';

/**
 * @param {React.ReactNode | undefined} element
 * @param {Object} params
 * @param {NonNullable<ExtendedRouteObject['userCanAccess']>} params.userCanAccess
 * @returns {{element: NonNullable<ExtendedRouteObject['element']>, userCanAccess: NonNullable<ExtendedRouteObject['userCanAccess']>}}
 */
export const withPrivateRoute = (element, { userCanAccess }) => ({
  element: <PrivateRoute userCanAccess={userCanAccess}>{element}</PrivateRoute>,
  userCanAccess,
});
